<template>
  <div>
    <b-modal
      ref="modal-primary"
      id="modal-primary"
      size="lg"
      modal-class="modal-primary"
      centered
      hide-footer
      title="Tahsilat Raporu Detay"
    >
      
      <vs-card>
        <div slot="header">
          <h4>Borç/Tahsilat Detay</h4>
        </div>
        <div>
          <ag-grid-vue
            style="width: 100%; height: 200px"
            class="ag-theme-alpine"
            :defaultColDef="defaultColDef"
            :localeText="localeText"
            :columnDefs="columnDefs"
            @grid-ready="onGridReady"
            :rowData="rowData"
            :rowClassRules="rowClassRules"
            @first-data-rendered="onFirstDataRendered"
            :headerHeight="headerHeight"
          ></ag-grid-vue>
        </div>
      </vs-card>
      <vx-card>
        <h4>Evrak Görselleri</h4>
      </vx-card>
    </b-modal>

    <button v-on:click="kartDetay()" style="border: none; background: none">
      <box-icon
        style="float: right"
        name="search-alt-2"
        animation="tada-hover"
        color="#7367F0"
        class="text-body align-middle mr-25"
      ></box-icon>
    </button>
    <vs-popup
      type="filled"
      title="Tahsilat Raporu Detay"
      :active.sync="popupKartDetay"
    ></vs-popup>
  </div>
</template>
<script>
import "boxicons";

import { BModal, BButton, VBModal, BAlert } from "bootstrap-vue";
import Store from "../../../../store/store";
import state from "../../../../store/state";
import Ripple from "vue-ripple-directive";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import moment from "moment";
export default {
  components: {
    AgGridVue,
    BButton,
    BModal,
    BAlert,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  data() {
    return {
      headerHeight: null,
      localeText: null,
      columnDefs: null,
      rowData: null,
      rowClassRules: null,
      popupKartDetay: false,
      tahsilatraporuDetay: [],
      borcList: [],
      tahsilatList: [],
      gridApi: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
        width: 125,
      },
    };
  },
  created() {
    this.headerHeight = 30;
    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
    this.rowClassRules = {
      // row style function
      "sick-days-warning": (params) => {
        var islem = params.data.ISLEM;
        return islem == "Borç";
      },
      // row style expression
      "sick-days-breach": 'data.ISLEM == "Tahsilat"',
    };
  },
  methods: {
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    parseDate(params) {
      return moment(String(params.value)).format("DD.MM.YYYY");
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    kartDetay() {
      //  this.popupKartDetay = true;
      this.$refs["modal-primary"].show();
      this.tahsilatraporuDetay = this.params.data;

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        ISLEM: "",
        RECEIPTNO: this.tahsilatraporuDetay.EVRAKNO,
      };
      var vm = this;

      soap.createClient(url, function (err, client) {
        client.INT_TAHSILATRAPORUDETAY(args, function (err, result) {
          if (result.INT_TAHSILATRAPORUDETAYResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          vm.veriler = JSON.parse(result.INT_TAHSILATRAPORUDETAYResult);
          vm.rowData = vm.veriler;
        });
      });
    },
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: "İşlem",
        field: "ISLEM",
        sortable: true,
        filter: true,
      },
      {
        headerName: "Banka",
        field: "TBANKA",
        sortable: true,
        filter: true,
      },
      {
        headerName: "Çek No",
        sortable: true,
        filter: true,
        field: "TCEKNO",
      },
      {
        headerName: "Vade",
        field: "TVADE",
        sortable: true,
        filter: true,
        valueFormatter: this.parseDate,
      },
      {
        headerName: "Gün",
        field: "TGUN",
        sortable: true,
        filter: true,
      },
      {
        headerName: "Çek Tutarı",

        field: "TTUTAR",
        sortable: true,
        filter: true,
      },
    ];
  },
};
</script>
<style lang="scss">
@import "~ag-grid-community/dist/styles/ag-grid.css";
@import "~ag-grid-community/dist/styles/ag-theme-alpine.css";
.ag-theme-alpine .ag-row {
  font-size: 13px;
  height: 35px;
}
#modal-primary___BV_modal_outer_ {
  z-index: 105000 !important;
}
[dir] .modal-title {
  margin-bottom: 0;
  color: #7367f0 !important;
}
[dir="ltr"] .modal .modal-header,
[dir="rtl"] .modal .modal-header {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
[dir] .modal .modal-header {
  background-color: #f8f8f8;
  border-bottom: none;
}
[dir="ltr"] .modal-header,
[dir="rtl"] .modal-header {
  border-top-left-radius: calc(0.358rem - 1px);
  border-top-right-radius: calc(0.358rem - 1px);
}
[dir] .modal-header {
  padding: 0.8rem 1.4rem;
  border-bottom: 1px solid #ebe9f1;
}

[dir="ltr"] .modal .modal-header .close:active,
[dir="ltr"] .modal .modal-header .close:focus,
[dir="ltr"] .modal .modal-header .close:hover {
  -webkit-transform: translate(5px, 3px);
  transform: translate(5px, 3px);
}

[dir] .modal .modal-header .close:active,
[dir] .modal .modal-header .close:focus,
[dir] .modal .modal-header .close:hover {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.modal.modal-primary .modal-header .close {
  color: #7367f0 !important;
}
.modal .modal-header .close:active,
.modal .modal-header .close:focus,
.modal .modal-header .close:hover {
  opacity: 1;
  outline: none;
}
[dir="ltr"] .modal-header .close {
  margin: -0.8rem -1.4rem -0.8rem auto;
}
[dir] .modal .modal-header .close {
  padding: 0.2rem 0.62rem;
  -webkit-box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  border-radius: 0.357rem;
  background: #fff;
}
.modal-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.sick-days-warning {
  background-color: rgb(248, 153, 153) !important;
}
[dir] button:not(:disabled),
[dir] [type="button"]:not(:disabled),
[dir] [type="reset"]:not(:disabled),
[dir] [type="submit"]:not(:disabled) {
  cursor: pointer;
  border: none;
}

.sick-days-breach {
  background-color: rgb(153, 248, 158) !important;
}
</style>